export default "__VITE_ASSET__DyHsrE9E__"